/** @format */
import { css } from 'styled-components';

import {
    largeTablet,
    mobile,
    smallMobile,
    smallTablet,
} from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

/* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
const baseStyles = () => css`
    position: relative;
    padding: 0 var(--layout-spacing-48);
    background: var(--gradients-brand-primary);
    display: grid;
    grid-template-rows: min-content min-content;

    .social-wrapper {
        display: flex;
        padding: var(--layout-spacing-64) 0;
        justify-content: space-between;
        align-items: center;

        .social-title {
            text-align: right;
            ${theme.typography.body_large};
            color: var(--colors-text-inverse);
            padding-right: var(--layout-spacing-24);
        }

        .social-icons {
            column-gap: var(--layout-spacing-16);
            .icon--resting {
                border-color: var(--colors-border-inverse);
                background: none;

                svg {
                    fill: var(--colors-text-inverse);
                }
            }
        }

        .social {
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
    }

    .mpb-hash {
        color: var(--colors-text-inverse);
        margin: 0;

        .mpb-hash-highlight {
            color: var(--colors-text-accent-inverse);
            font-weight: 700;
        }
    }

    .join-now {
        margin-top: -10rem;
    }

    ${largeTablet(css`
        .social-wrapper {
            padding: var(--layout-spacing-64) var(--layout-spacing-24);
        }
    `)}

    ${smallTablet(css`
        padding: 0 var(--layout-spacing-24);

        .social-wrapper .social-title {
            padding-right: var(--layout-spacing-12);
        }

        .join-now {
            margin-top: -13rem;
        }
    `)}

    ${mobile(css`
        padding: 0 var(--layout-spacing-12);

        .social-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: var(--layout-spacing-48) 0;
            gap: var(--layout-spacing-48);

            .mpb-hash {
                margin-bottom: 0;
            }
        }

        .join-now {
            margin-top: -16rem;
        }
    `)}

    ${smallMobile(css`
        .social-wrapper {
            gap: var(--layout-spacing-24);

            .social-title {
                padding-right: 0;
            }
        }

        .social {
            flex-direction: column;
            gap: var(--layout-spacing-24);
        }

        .join-now {
            margin-top: -19rem;
        }
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

export const styles = () => css`
    ${baseStyles()}
`;
